import vipService from '@api/vipConfig'
import service from '@api/config'

// 查询邀工币变动  type:类型 1-获取，2-使用
export const coinRecord = (data) => {
  return vipService.request({
    url: `/coin/record`,
    method: 'post',
    data: data
  })
}

//  获取置顶所需邀工币数量
export const onceTopCoins = (data) => {
  return vipService.request({
    url: `/coin/onceTopCoins`,
    method: 'post',
    data: data
  })
}

// 置顶   dataId  项目id或者找活id   dataType 数据类型：1-招工；2-找活
export const topByCoin = (data) => {
  return vipService.request({
    url: `/coin/topByCoin`,
    method: 'post',
    data: data
  })
}

// 充值列表
export const coinPrice = (data) => {
  return vipService.request({
    url: `/coin/price`,
    method: 'post',
    data: data
  })
}

// 购买邀工币支付
export const payCoin = (data) => {
  return vipService.request({
    url: `/coin/pay`,
    method: 'post',
    data: data
  })
}

// 购买邀工币数量支付
export const payCoinNum = (data) => {
  return vipService.request({
    url: `/coin/v4.0/pay`,
    method: 'post',
    data: data
  })
}

// 获取积分数
export const getNo = () => {
  return vipService.request({
    url: `/score/getNo`,
    method: 'post'
  })
}

// 查询订单状态
export const orderQuery = (data) => {
  return vipService.request({
    url: `/coin/order/query`,
    method: 'post',
    data: data
  })
}

// 支付开关页面
export const payOpen = (data) => {
  return vipService.request({
    url: `/coin/pay/open?deviceType=` + data,
    method: 'post',
    data: data
  })
}

// 获取置顶时间
export const topDays = (data) => {
  return service.request({
    url: `/data/topDays`,
    method: 'post',
    data: data
  })
}

// 获取置顶数据
export const topInfo = (data) => {
  return service.request({
    url: `/top/info`,
    method: 'post',
    data: data
  })
}

// 临时存需要传递数据
export const dataSave = (data) => {
  return service.request({
    url: `/common/temp/data/save`,
    method: 'post',
    data: data
  })
}

// 获取临时储存数据
export const dataGet = (data) => {
  return service.request({
    url: `/common/temp/data/get?uid=` + data,
    method: 'post',
    data: data
  })
}

// 获取banner
export const getBanner = (data) => {
  return vipService.request({
    url: `/coin/banner`,
    method: 'post',
    data: data
  })
}

// getPhone
export const getPhone = (data) => {
  return service.request({
    url: `/user/getPhone`,
    method: 'post',
    data: data
  })
}
